export class RuleDeleteCommand{
    ruleId:string;

    constructor(ruleId:string){
        this.ruleId = ruleId;
    }
}